import { TimeRange } from "../../utils/timerange";

// type DashboardFilters = {
//   timeRange: TimeRange;
//   sentiment: string;
//   relevance: string;
//   risk: string;
//   protocol: string;
//   user: string;
//   processDecision: string;
//   callType: string;
// };

export const convertFiltersToURLSearchParams = (
  filters: {
    timeRange: TimeRange;
    sentiment: string;
    relevance: string;
    risk: string;
    protocol: string;
    user: string;
    processDecision: string;
    callType: string;
  },
  additionalFilter?: { key: string; value: string }
): URLSearchParams => {
  const params = new URLSearchParams();

  // Set time range
  if (filters.timeRange) {
    params.set("time_range", filters.timeRange);
  }

  // Set other filters only if they're not "all"
  if (filters.sentiment !== "all") {
    params.set("sentiment", filters.sentiment);
  }

  if (filters.relevance !== "all") {
    params.set("relevance", filters.relevance);
  }

  if (filters.risk !== "all") {
    params.set("ra_overall_indicator", filters.risk);
  }

  if (filters.protocol !== "all") {
    params.set("sc_name", filters.protocol);
  }

  if (filters.user !== "all") {
    params.set("user_email", filters.user);
  }

  if (filters.processDecision !== "all") {
    params.set("pp_process_decision", filters.processDecision);
  }

  if (filters.callType !== "all") {
    params.set("call_type", filters.callType);
  }

  // Add additional filter if provided
  if (additionalFilter) {
    params.set(additionalFilter.key, additionalFilter.value);
  }

  return params;
};
